export default "__VITE_ASSET__776ece02__"